export function fetchQuizStats(elem) {
    if (!elem) return;

    const API_ENDPOINT = "/umbraco/api/quiztrackerapi/getcount";
    const countEl = elem.querySelector(".participant-count");
    const waveProgress = elem.querySelector(".wave-progress")
    const targetParticipants = parseFloat(waveProgress.dataset.target, 10);
    const svg = waveProgress.querySelector('svg');

    fetch(API_ENDPOINT)
    .then((response) => {
        if (!response.ok) {
            throw new Error("Network response was not ok");
        }
        return response.json();
    })
    .then((data) => {
        const totalParticipants = data;
        countEl.textContent = totalParticipants.toLocaleString();
        waveProgress.setAttribute('data-progress', totalParticipants);
    })
    .catch((error) => {
        console.error("Failed to fetch participant count:", error);
        countEl.textContent = "—";
    });

    function setWaveProgress(currentValue) {
        if (!isNaN(currentValue)) {
            const percent = (currentValue / targetParticipants) * 100;
            const path = document.querySelector(".wave-progress-path-percent");
            const totalLength = path.getTotalLength();
            const visibleLength = totalLength * (percent / 100);
            const swimmer = waveProgress.querySelector('.wave-progress__swimmer');

            path.style.transition = "none";
            path.style.strokeDasharray = totalLength;
            path.style.strokeDashoffset = totalLength;

            // Force reflow to apply the reset state
            void path.getBoundingClientRect();

            // Re-enable transition
            path.style.transition = "stroke-dashoffset 2s ease-in-out";

            // Set final offset
            path.style.strokeDashoffset = totalLength - visibleLength;

            // Optional: change stroke color here if needed
            path.classList.add("has-progress");

            // Swimmer marker
            const svgRect = svg.getBoundingClientRect();
            const svgWidth = svgRect.width;

            if (svgWidth && svg.viewBox.baseVal.width && !isNaN(visibleLength)) {
                const point = path.getPointAtLength(visibleLength);
                const swimmerWidth = swimmer.offsetWidth || 80; // fallback width
                const triggerOffset = swimmerWidth;

                // Calculate left offset along the SVG path
                const offsetLeft = (point.x / svg.viewBox.baseVal.width) * svgWidth;

                // Only move swimmer if it has room to move beyond initial offset
                if (offsetLeft >= triggerOffset) {
                    const adjustedLeft = offsetLeft - (swimmerWidth / 2);
                    swimmer.style.left = `${adjustedLeft}px`;
                } else {
                    swimmer.style.left = `-14px`; // initial resting position
                }        
            }
        }
    }

    function startIntersectionObserver() {
        const observer = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const currentValue = parseInt(waveProgress.dataset.progress, 10);
                        setWaveProgress(currentValue);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.5 }
        );

        observer.observe(waveProgress);
    }

    if (waveProgress) {
        const mutationObserver = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === "attributes" && mutation.attributeName === "data-progress") {
                    const currentValue = parseInt(waveProgress.dataset.progress, 10);
                    if (!isNaN(currentValue)) {
                        startIntersectionObserver(); // Now it's safe
                        mutationObserver.disconnect(); // Stop observing
                    }
                }
            }
        });

        mutationObserver.observe(waveProgress, { attributes: true });
    }
}
